<div>
  <div class="row mb-3">
    <div class="col-12 px-0">
      <div class="wccard rounded border p-3">
        <div class="row">
          <div class="col-8 my-auto">
            <p class="mb-0 f-16 font-weight-500"><ng-container *ngIf="searchOngoing">Searching "{{searchFormControl.value}}" in </ng-container>{{ category }} Integrations</p>
          </div>
          <div class="col-4">
            <div class="position-relative">
              <div class="position-absolute p-2" style="top: 50%; left: 0;transform: translateY(-50%); pointer-events: none;">
                <i class="fas fa-search"></i>
              </div>
              <input data-testid="auto-app-integration-input-1" type="text" class="wc-form-control pl-6" [placeholder]="'Search in integrations'" [formControl]="searchFormControl">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 px-0">
      <div class="bg-gray p-3" style="border-radius: 1rem;">
        <!-- alert for team admin to notify that they have to connect integration first to actiavte it for other -->
        <div class="alert alert-warning f-12 position-initial p-2 m-0 w-100 mb-3 border border-warning" role="alert" *ngIf="isTeamAdmin && !activeIntegrations.length && !searchOngoing">
          <i class="fa-exclamation-triangle fa-regular mr-1"></i> Please connect an integration to activate it for your team.
        </div>
        <div class="mb-3" *ngIf="activeIntegrations.length">
          <div class="mb-2">
            <h3 class="f-16 font-weight-500 text-484b59">Active Integrations ({{ activeIntegrations.length }})</h3>
          </div>
          <div class="d-grid" style="grid-template-columns: 1fr 1fr 1fr 1fr;gap: 0.8rem;">
            <div *ngFor="let integration of activeIntegrations">
              <app-integration-unit (update)="showIntegrationState($event)" [integration]="integration" [isAtsConnected]="isAtsConnected"></app-integration-unit>
            </div>
          </div>
        </div>
        <div class="mb-3" *ngIf="availableIntegrations.length">
          <div class="mb-2">
            <h3 class="f-16 font-weight-500 text-484b59">Available Integrations ({{ availableIntegrations.length }})</h3>
          </div>
          <div class="d-grid" style="grid-template-columns: 1fr 1fr 1fr 1fr;gap: 0.8rem;">
            <div *ngFor="let integration of availableIntegrations">
              <app-integration-unit (update)="showIntegrationState($event)" [integration]="integration" [isAtsConnected]="isAtsConnected"></app-integration-unit>
            </div>
          </div>
        </div>
        <!-- alter for team members to notify that they need to contact team admin to connect to integration first -->
        <div class="alert alert-info f-12 position-initial p-2 m-0 w-100 mb-3 border border-info" role="alert" *ngIf="!isTeamAdmin && inactiveIntegrations.length">
          <i class="fa-exclamation-triangle fa-regular mr-1"></i> Please contact your team admin to connect an integration. Once connected, you can connect it for yourself.
        </div>
        <div class="mb-3" *ngIf="inactiveIntegrations.length">
          <div class="mb-2">
            <h3 class="f-16 font-weight-500 text-484b59">Other Integrations ({{ inactiveIntegrations.length }})</h3>
          </div>
          <div class="d-grid" style="grid-template-columns: 1fr 1fr 1fr 1fr;gap: 0.8rem;">
            <div *ngFor="let integration of inactiveIntegrations">
              <app-integration-unit (update)="showIntegrationState($event)" [integration]="integration" [isAtsConnected]="isAtsConnected"></app-integration-unit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
